<template>
  <layout>
    <section class="section">
      <div v-if="Object.keys(errors).length" class="columns">
        <div class="column">
          <div class="box">
            <div class="title-bar">
              <h3>Import Errors</h3>
            </div>
            <ImportErrorsTable :errors="errors" />
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="box newFeedbackGiverBox">
            <div class="title-bar">
              <h3>Add New Feedback Givers</h3>
              <div class="buttons">
                <b-loading
                  :is-full-page="isFullPage"
                  v-model="isLoading"
                  :can-cancel="true"
                ></b-loading>
                <csv-upload @uploaded="csvSubmit" v-model="feedbackGiverCSV" />
              </div>
            </div>
            <hr />
            <div class="columns">
              <div class="column">
                <form action="#">
                  <div class="columns">
                    <div class="column is-flex is-align-items-center">
                      <b-field label="First Name">
                        <b-input
                          v-model="feedbackGiver_form.first_name"
                        ></b-input>
                      </b-field>
                    </div>
                    <div class="column is-flex is-align-items-center">
                      <b-field label="Last Name" expanded>
                        <b-input
                          v-model="feedbackGiver_form.last_name"
                        ></b-input>
                      </b-field>
                    </div>
                    <div class="column is-flex is-align-items-center" expanded>
                      <b-field label="Email">
                        <b-input v-model="feedbackGiver_form.email"></b-input>
                      </b-field>
                    </div>
                  </div>
                  <div class="linkFeedbackGiverToParticipants">
                    <div
                      class="columns"
                      v-for="(
                        participant, index
                      ) in feedbackGiver_form.linkedParticipants"
                      :key="index"
                    >
                      <div class="column is-flex is-align-items-center">
                        <b-field label="Participant Name">
                          <b-select
                            v-model="participant.unique_id"
                            expanded
                            @input="participantLinkChange()"
                          >
                            <option
                              v-for="participant in project.participants"
                              :key="participant.unique_id"
                              :value="participant.unique_id"
                            >
                              {{ participant.first_name }}
                              {{ participant.last_name }}
                            </option>
                          </b-select>
                        </b-field>
                      </div>
                      <div class="column is-flex is-align-items-center">
                        <b-field label="Relationship">
                          <b-select
                            v-model="participant.relationship_id"
                            expanded
                            @input="participantLinkChange()"
                          >
                            <option
                              v-for="relationship in project.relationships"
                              :key="relationship.unique_id"
                              :value="relationship.unique_id"
                            >
                              {{ relationship.name }}
                            </option>
                          </b-select>
                        </b-field>
                      </div>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column">
                      <b-button
                        @click="addFeedbackGiver()"
                        class="button is-primary"
                        :disabled="!isAddable"
                        >Add</b-button
                      >
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column is-justify-content-flex-end">
          <inertia-link
            :href="redirect || route('projects.show', project.unique_id)"
          >
            <button class="button is-primary">Next</button>
          </inertia-link>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import Layout from '../Layout';
import CsvUpload from '../../../Components/Management/CsvUpload';
import ImportErrorsTable from '@/Components/Management/ImportErrorsTable';

class FeedbackGiver {
  constructor(args) {
    this.first_name = args.first_name ?? '';
    this.last_name = args.last_name ?? '';
    this.email = args.email ?? '';
    this.linkedParticipants = [
      {
        unique_id: '',
        relationship_id: '',
      },
    ];
  }
}

export default {
  components: {
    Layout,
    CsvUpload,
    ImportErrorsTable,
  },
  props: {
    project: { type: Object },
    feedbackGivers: { type: Array },
    redirect: { type: String },
    errors: { type: Object },
  },
  data() {
    return {
      feedbackGiver_form: new FeedbackGiver({ first_name: '' }),
      loadingFeedbackGivers: [],
      feedbackGiverCSV: null,
      isLoading: false,
      isFullPage: true,
    };
  },
  methods: {
    csvSubmit: function (file) {
      const data = new FormData();
      data.append('type', 'feedback_givers');
      data.append('file', file);
      this.$inertia.post(
        route('projects.setup.feedbackGiverCSV', this.project.unique_id),
        data,
        {
          onStart: () => {
            this.isLoading = true;
          },
          onFinish: () => {
            this.isLoading = false;
          },
        }
      );
    },
  },
};
</script>
